import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { JWTProvider } from '@piwikpro/ui-components';
import { withInject } from '@piwikpro/platform';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { Session } from '@piwikpro/auth-crate/Session';
import ChangePlanOverlay from './ChangePlanOverlay';

const mapStateToProps = (state: { session: SessionState }) => ({
  jwt: state.session.jwt,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface Props extends ReduxProps {
  session: Session
}

const ChangePlanOverlayWithDataProvider = ({ jwt, session }: Props) => (
  <JWTProvider jwt={jwt!} refreshJWT={session.refreshJWT}>
    <ChangePlanOverlay />
  </JWTProvider>
);

export default withInject({
  session: 'AuthCrate.session',
})(connector(ChangePlanOverlayWithDataProvider));
